import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import Typography from '../../base/Typography';

export const QuoteContainer = styled.blockquote`
  /* With the border */
  && {
    ${({ theme, borderColor, hasBorder }) => (hasBorder
    && css`
      border-left: ${rem('5px')}; solid ${borderColor};
      padding-left: ${theme.spacing(3).rem()};
      
    `)}
  }
  /* default */
  && {
      margin-left: 0;
      margin-right: 0;
  }
`;

export const QuoteTypography = styled(Typography)`
  &&& {
    ${({ theme }) => css`
      font-weight: 400;
    `}
  }
`;

export const QuoteFigure = styled.figure`
  ${({ theme }) => css`
      margin: 0;

      .icon-fill {
        @media print {
          fill: ${theme.colors.neutral.black}
        }
      }
    `}
`;
